/**
 * @returns a filter string to be used as a static filter
 */
export const buildStoreFilter = (storeId?: number | string) =>
  storeId ? `store_id = ${storeId}` : '';
